/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * A sparse serializer representing all possible ProgramItems: [DeploymentProgramItem, ScoreCardSetProgramItem].
 */
export type ProgramItem = {
  weight: number
} & (
  | {
      item_type: ProgramItem.item_type.PROJECT
      project: {
        uuid: string
        name: string
      }
    }
  | {
      item_type: ProgramItem.item_type.SCORECARDSET
      scorecard_set: {
        uuid: string
        name: string
      }
    }
)
export namespace ProgramItem {
  /**
   * * `scorecardset` - scorecardset
   * * `project` - project
   */
  export enum item_type {
    SCORECARDSET = "scorecardset",
    PROJECT = "project",
  }
}
